import {useInfiniteQuery} from 'react-query';
import useInfiniteScroll from '../../../utilities/hooks/useInfiniteScroll';
import {getUserOrderList} from './getUserOrderList';
import {IUserOrderListPayload} from './types';

const useGetUserOrderList = (payload?: IUserOrderListPayload) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery(
    ['get-user-order-list', payload],
    async ({pageParam = 1}) => getUserOrderList({pageParam, payload}),
    {
      enabled: payload?.enabled ?? true,
      // v3 uses this (NOT `initialPageParam`)
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage.next) return undefined;
        return allPages.length + 1;
      },
    },
  );

  const data = rawData?.pages.flatMap(page => page.results);

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
  };
};

export default useGetUserOrderList;
